export default "//0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/e9d2a83d2696c98f8ca36d484c54b496.jpg";